import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, viewChild, ViewChild } from '@angular/core';
import { FormStateService } from '../../module/service-provider/add-sp-new-component/form-state.service';
import { ServiceProviderService } from '../../Service/Service-providers/service-provider.service';
import { ServiceDistributorComponent } from '../service-distributor.component';
import { DistributorBusinessDetailsComponent } from '../distributor-business-details/distributor-business-details.component';
import { DistributorsSponsorOwnerDetailsComponent } from '../distributors-sponsor-owner-details/distributors-sponsor-owner-details.component';
import { ServiceDistributorStatusComponent } from '../service-distributor-status/service-distributor-status.component';
import { ActivatedRoute } from '@angular/router';
import { MapLocationComponent } from '../../location/map-location/map-location.component';
import { AddressproofComponent } from '../../location/addressproof/addressproof.component';
import { Location } from '@angular/common';

@Component({
  selector: 'app-add-distributor',
  templateUrl: './add-distributor.component.html',
  styleUrl: './add-distributor.component.scss'
})
export class AddDistributorComponent implements OnInit, AfterViewInit {

  @Input() phoneNumber!: string;
  technicianInfo: any;
  editMode: boolean = false;
  @Input() id?: number;
  idToBePass?: number;
  selectedBusinessType: any;
  selectedServices!: any[];
  countryId: any;
  distributorId: any;
  businessName = '';
  coiDocument: any = null;
  iodDocument: any = null;
  imgPath = '';
  emailAddress = '';
  address = '';
  name = '';
  contact = '';
  status = '';
  businessType = '';
  submittedBy = '';
  email = '';
  gst = '';
  stateId = '';
  city = '';
  zip = '';
  district = '';
  date = '';
  commencementYear = '';
  website = '';
  authorisedDelarshipProofUrl = '';
  commercialRegistrationNumber = '';
  documentName = '';
  planName = 'Basic';
  paidAmount = '₹299/-';
  servicedistributor: any;
  userName = '';
  distributorNetworks: any[] = [];
  documents: any[] = [];
  frontViewFiles: any[] = [];
  selectedDocumentUrl: string | undefined;
  visible = false;
  visibleReject = false;
  visibleViewer = false;
  showDocumentViewer = false;
  ownerEmailAddress = '';
  ownerPhoneNumber = '';
  IDProofofOwner = '';
  CVofestablishmentOwner = '';
  model: any = {
    documents: [],
  }

  locationComplete: boolean = false;
addressProofComplete: boolean = false;
businessDetailsComplete: boolean = false;
ownerDetailsComplete: boolean = false;

  constructor(
    private cdr: ChangeDetectorRef,
    public formstate: FormStateService,
    private api: ServiceProviderService,
    private route: ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit(): void {
    const finalId = this.route.snapshot.paramMap.get('distributorId')
    this.id = this.id || +finalId!
    console.log('Recieved Id from route:', this.id)
    this.editMode = !!this.id;
    this.setActiveSection(this.activeSection)
  }
  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }
  @ViewChild(ServiceDistributorComponent)
  serviceDistributor!: ServiceDistributorComponent;

  @ViewChild(DistributorBusinessDetailsComponent)
  businessDetailsFormComponent!: DistributorBusinessDetailsComponent;

  @ViewChild(DistributorsSponsorOwnerDetailsComponent)
  ownerDetails!: DistributorsSponsorOwnerDetailsComponent;

  @ViewChild('ServiceDistributorStatus', { static: false })
  ServiceDistributorStatus!: ServiceDistributorStatusComponent;

  @ViewChild(MapLocationComponent) mapLocation!: MapLocationComponent;
  @ViewChild(AddressproofComponent) addressProof!: AddressproofComponent;

  @Output() updateServiceDistributorList = new EventEmitter<void>();

  @Output() closeDialog = new EventEmitter<void>();

  activeSection: string = 'map-location';
  selectedPlan: any = null;



  setActiveSection(section: string): void {
    this.activeSection = section;
    console.log('Add-Distributor component=', this.activeSection);
    console.log('Edit mode::', this.editMode)
    if (this.activeSection === 'map-location' && this.editMode && this.id) {
      this.serviceDistributorById(this.id)
    }
    if (this.activeSection === 'business-details' && this.editMode && this.id) {
      this.serviceDistributorById(this.id)
    }
    if (this.activeSection === 'owner-details' && this.editMode && this.id) {
      this.serviceDistributorById(this.id)
    }
    if (this.activeSection === 'address-proof' && this.editMode && this.id) {
      this.serviceDistributorById(this.id)
    }
  }
 

  onUpdateServiceDistributorList(): void {
    this.updateServiceDistributorList.emit();
  }

  onPlanSelected(plan: any): void {
    this.selectedPlan = plan;
  }

  close() {
    this.formstate.clearFormData();
    this.closeDialog.emit();
    this.location.back()
  }

  setCountryId(countryId: string) {
    this.countryId = countryId;
  }
  handleFinish(): void {
    if (this.ServiceDistributorStatus) {
      this.ServiceDistributorStatus.refreshData();
    }
  }
  serviceDistributorById(id: number) {
    this.api.getDistributorById(id).subscribe((res: any) => {
      if (!res) return;
      console.log('responsephoneNumber=', res.phoneNumber);
      this.phoneNumber = res.phoneNumber
      const formData = {

        ownerDetails: {
          documents: res.documents || [],
          ownerName: res.ownerName,
          ownerPhoneNumber: res.ownerPhoneNumber,
          ownerEmailAddress: res.ownerEmailAddress,
          IDProofofOwner: res.documents?.find((doc: any) => doc.documentTypeId === 7)?.fileId,
          CVofestablishmentOwner: res.documents?.find((doc: any) => doc.documentTypeId === 20)?.fileId,
        },
        addressProof: {
          documents: res.documents || [],
          addressProof: res.documents?.find((doc: any) => doc.documentTypeId === 5)?.fileId,
        }
      };
      console.log('Form Data Set:', res);
      //this.documentsLoaded = true;
      if (this.businessDetailsFormComponent) {
        this.documents = res?.documents || [];
        this.businessDetailsFormComponent.model = { ...this.businessDetailsFormComponent.model, ...res.businessDetails };
        this.distributorNetworks = res?.distributorNetworks,
          this.businessDetailsFormComponent.form.patchValue(res);
        this.businessDetailsFormComponent.populateFormWithDistributorDetails(res);
        this.cdr.markForCheck();
        this.cdr.detectChanges();
      }
      if (this.ownerDetails) {
        this.documents = formData.ownerDetails?.documents || [];
        this.ownerDetails.model = { ...this.ownerDetails.model, ...formData.ownerDetails };
        this.ownerDetails.populateFormWithDistributorDetails(formData.ownerDetails)
        this.ownerDetails.form.patchValue(formData.ownerDetails);
        //this.ownerDetails.cdr.detectChanges();
        this.cdr.markForCheck();
        this.cdr.detectChanges();
        setTimeout(() => {
          this.cdr.detectChanges();
        });

      }
      if (this.activeSection === 'map-location' && this.mapLocation) {
        this.mapLocation.populateLocationFromBackend(res);
      }
      if (this.addressProof && this.activeSection === 'address-proof') {
        this.documents = formData.ownerDetails?.documents || [];
        this.addressProof.model = { ...this.addressProof.model, ...formData.ownerDetails };
        this.addressProof.populateAddressProofFromResponse(res)
      }
    }, (error) => {
      console.error('Error fetching distributor details:', error);
    });
  }

}
